// This import loads the firebase namespace along with all its type information.
import MediaProcessJobOverview from './media-process-job-overview-model'

export async function load_mediaProcessJobOverviews(): Promise<
  MediaProcessJobOverview[]
> {
  throw 'Not implemented'
}

export async function delete_mediaProcessJobOverview(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mediaProcessJobOverview(): Promise<MediaProcessJobOverview> {
  throw 'Not implemented'
}
